import { saveChartState } from "../services/api";
import type { MeasurementChartModel } from "../types";
import MeasurementChart from "./MeasurementChart";

type ScalingState = {
  horizontalAxisMin: number;
  horizontalAxisMax: number;
  verticalAxisMin: number;
  verticalAxisMax: number;
};

type Props = {
  model: MeasurementChartModel;
  registerRangeReference?: (instance: import("./RangeInput").RangeInputRef) => void;
  registerChartReference?: (instance: MeasurementChart) => void;
  onPlotVisibilityChanged?: (
    event: unknown,
    legendItem: { text?: string; datasetIndex?: number },
    legend: unknown
  ) => void;
  getHiddenPointIds?: () => number[];
  getHiddenDatasets?: () => string[];
  profileId?: number;
};

export default function MeasurementChartContainer({
  model,
  registerRangeReference,
  registerChartReference,
  onPlotVisibilityChanged,
  getHiddenPointIds,
  getHiddenDatasets,
  profileId
}: Props) {
  const onAxesRangesChanged = (scaling: ScalingState) => {
    if (!model.options.scalingControls?.saveState) {
      return;
    }

    void saveChartState(
      model.chartName,
      scaling.horizontalAxisMin,
      scaling.horizontalAxisMax,
      scaling.verticalAxisMin,
      scaling.verticalAxisMax
    );
  };

  return (
    <div className="MeasurementChartContainer">
      <MeasurementChart
        chartName={model.chartName}
        options={model.options}
        data={model.data}
        height={model.height}
        legendDivId={model.legendDivId}
        onRangeChanged={onAxesRangesChanged}
        registerRangeReference={registerRangeReference}
        registerChartReference={registerChartReference}
        onPlotVisibilityChanged={onPlotVisibilityChanged}
        isLongitudinalProfileChart={model.isLongitudinalProfileChart}
        getHiddenPointIds={getHiddenPointIds}
        getHiddenDatasets={getHiddenDatasets}
        yParameterTypeIds={model.yParameterTypeIds}
        profileId={profileId}
        useLiveDataAccessor={model.useLiveDataAccessor}
      />
    </div>
  );
}
